import createHistory from "history/createBrowserHistory";

import * as _api from "./api";
import * as _notifications from "./notifications";

export const api = _api;
export const history = createHistory();
export const notifications = _notifications;
